// Exports
export default {
	"ContentContainer": "ContentContainer_oASob",
	"ImageContainer": "ImageContainer_PzyO6",
	"ContentText": "ContentText_Uwvz6",
	"HeaderText": "HeaderText_1uG5L"
};
